import {
	Component,
	EventEmitter,
	Input,
	Output,
	booleanAttribute,
	ChangeDetectionStrategy,
} from "@angular/core"
import { COMMON_IMPORTS } from "@app/common-imports"
import { HomePersonColumns, ReportItemType } from "@app/definitions/types"
import { LangValPipe } from "../lang-val.pipe"

@Component({
	selector: "app-mobile-tabs",
	imports: [COMMON_IMPORTS, LangValPipe],
	changeDetection: ChangeDetectionStrategy.Eager,
	template: `
		<ul
			[class.three-tabs]="isHome"
			class="d-lg-none d-flex justify-content-start mobile-tabs"
		>
			@for (tab of tabNames; track tab) {
				<li
					class="text-center"
					[class.active]="activeColumn == tab"
					(click)="onClick.emit(tab)"
				>
					{{ tabToLang[tab] | langVal }}
				</li>
			}
		</ul>
	`,
})
export class MobileTabsComponent {
	@Input() personType: ReportItemType
	@Input() activeColumn: HomePersonColumns
	@Input({ transform: booleanAttribute }) isHome: boolean = false
	@Output() onClick = new EventEmitter()
	tabNames: string[] = ["calendar", "center", "sideItems"]
	tabToLang: any = {
		calendar: "calendar",
		center: "followup",
		sideItems: "patient_file",
	}

	ngOnInit() {
		if (!this.isHome) {
			this.tabNames.shift()
			this.tabToLang = {
				center: this.personType,
				sideItems: this.personType + "_details",
			}
		}
	}
}
